import React from 'react';
import PropTypes from 'prop-types';

import { BroadcasterItem } from './BroadcasterItem';
import { useGetMatchEventsQuery } from 'common/store/modules/api/content-api';
import { useSingleSiteSetting } from 'common/react/hooks/use-single-site-setting';

// in order of display
const BROADCASTERS = ['Channel 7', '7plus', 'Foxtel', 'Kayo'];

const filterAndSort = (items) => {
    const filtered = items.filter((item) => BROADCASTERS.includes(item.name));
    const sorted = filtered.sort(
        (a, b) => BROADCASTERS.indexOf(a.name) - BROADCASTERS.indexOf(b.name)
    );
    return sorted;
};

export const Broadcasters = ({
    match,
    matchId,
    compseasonId,
    roundNumber,
    disableRounds
}) => {
    const selectedRegion = useSingleSiteSetting('region');

    const { data } = useGetMatchEventsQuery({
        compseason: compseasonId,
        round: disableRounds ? match.round.roundNumber : roundNumber,
        pageSize: 15
    });

    const matchEvent = data?.content?.find(
        (item) => matchId === item.contentReference.id
    );
    let broadcasters = [];
    let orderedBroadcasters = [];

    if (matchEvent) {
        broadcasters =
            PULSE.app.common.broadcast.extractBroadcastersFromMatchEvent(
                matchEvent,
                selectedRegion?.id
            );
    }

    // Before rendering, we need to check whether we should be displaying
    // delayed broadcasters for Channel 7 & 7plus - https://bigpond.jira.com/browse/AFLP-8146

    if (broadcasters) {
        const delayCheckedBroadcasters = [];

        broadcasters.forEach((broadcaster) => {
            // get the channels for the broadcaster
            const broadcasterChannels = matchEvent?.channels.filter(
                (channel) => channel.info.broadcaster?.id === broadcaster.id
            );

            let showDelayed = false;
            let showNormal = false;

            // remove channels that are not configured for current region
            const filteredChannels = broadcasterChannels?.filter((channel) =>
                PULSE.app.common.broadcast.itemVisibleForRegion(
                    channel,
                    selectedRegion.id
                )
            );

            if (
                broadcaster.name === 'Channel 7' ||
                broadcaster.name === '7plus'
            ) {
                // If the broadcaster is Channel 7 or 7plus, we need to check for delayed broadcasts
                filteredChannels?.forEach((channel) => {
                    const isDelayed = channel.customAttributes?.find(
                        (item) =>
                            item.name === 'isDelayed' && item.value === 'true'
                    );
                    if (isDelayed) {
                        showDelayed = true;
                    } else {
                        showNormal = true; // If not delayed, we show normal
                    }
                });
            } else {
                showNormal = true; // For other broadcasters, we show normal broadcasts by default
            }

            const item = {
                ...broadcaster,
                showDelayed,
                showNormal
            };

            delayCheckedBroadcasters.push(item);
        });

        orderedBroadcasters = filterAndSort(delayCheckedBroadcasters);
    }

    return orderedBroadcasters?.length ? (
        <div className="fixtures__broadcaster-container">
            {orderedBroadcasters.map((broadcaster) => {
                return (
                    <BroadcasterItem
                        broadcaster={broadcaster}
                        key={broadcaster.id}
                    />
                );
            })}
        </div>
    ) : (
        <></>
    );
};

Broadcasters.propTypes = {
    match: PropTypes.object,
    matchId: PropTypes.any.isRequired,
    compseasonId: PropTypes.number.isRequired,
    roundNumber: PropTypes.number.isRequired,
    disableRounds: PropTypes.bool
};
